export const METHOD_OPTIONS = {
  LAST_PERIOD: 'lastPeriod',
  CONCEPTION_DATE: 'conceptionDate',
}
